export default "__VITE_ASSET__DXeyY3gm__"